"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
// @ts-ignore
var orgh_filter_helper_1 = __importDefault(require("@qualtrics-dashboard/orgh-filter-helper"));
/**
 * Simple angular wrapper for the orgh-filter-helper npm package
 */
(function (module) {
    module.factory('pr.orgHierarchyFilterHelper', [
        'rsEnvironment',
        function (env) {
            return new orgh_filter_helper_1.default(env);
        }
    ]);
})(angular_1.module('qualtrics.pr'));
